export const CHUNK_FAILED_MESSAGE = 'Failed to fetch dynamically imported module:'

export const CHUNK_FAILED_THROTTLE = 10 * 1000 * 60 // 10 minutes

export const CORE_CHUNK_FAILED_STORAGE_KEY = '__CORE_CHUNK_FAILED_STORAGE_KEY'
